import { Planner }   from "../../planner_base";
import watch from "redux-watch";
import isEqual from 'is-equal';
import {
  PLANNER_SHOW_ORDERS_PHASE_TT,
  PLANNER_HIDE_ORDERS_PHASE_TT,
} from 'apps/events';
class OrdersPhase extends Planner {
  indexStyle: string; //css for index label
  ttData: any;
  init(){
    super.init();
    this.ttData = {}
    this.watch();
    document.addEventListener(PLANNER_SHOW_ORDERS_PHASE_TT, (e) => this.showTooltip(e));
  }
  showTooltip(e){
    let overOrdersPhase = e.detail.orders_planner.overOrdersPhase;
    this.ttData = overOrdersPhase;
    this.update();
  }
}
riot.mixin('orders.planner.tooltip.orders-phase', OrdersPhase as riot.TagMixin)
